import AddTagModal from './tags/AddTagModal';
import PaymentChatModal from './PaymentChatModal';

function Modals({ blockInteraction }) {
  return (
    <>
      <AddTagModal />
      <PaymentChatModal blockInteraction={blockInteraction} />
    </>
  );
}

export default Modals;
